import { useContext } from 'react'
import { AuthorizationContext } from 'src/contexts'

export const useAuthorized = () => useContext(AuthorizationContext)
